<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="4" lg="6" >
                    <b-form-group :label="$t('course')">
                        <div class="label-as-input"> {{ formData.course_code + ' / ' + formData.course_name }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <b-form-group :label="$t('subject')">
                        <div class="label-as-input"> {{ isNotNullValue(formData.subject) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <b-form-group :label="$t('subtitle')">
                        <div class="label-as-input"> {{ isNotNullValue(formData.subtitle) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <b-form-group :label="$t('teaching_staff')">
                        <div class="label-as-input"> {{ formData.instructor_name ? formData.instructor_name + ' ' + formData.instructor_surname : '-' }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <b-form-group :label="$t('section')">
                        <div class="label-as-input"> {{ isNotNullValue(formData.section) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <ValidationProvider name="date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('date')">
                            <b-form-input type="date"
                                          v-model="formData.date"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <ValidationProvider name="start_time" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_time')">
                            <b-form-input type="time" v-model="formData.start_time"
                                          :class="errors[0] ? 'is-invalid' : ''"
                                          :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <ValidationProvider name="end_time" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('end_time')">
                            <b-form-input type="time" v-model="formData.end_time"
                                          :class="errors[0] ? 'is-invalid' : ''"
                                          :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <ValidationProvider name="classroom_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('classroom')">
                            <classroom-selectbox :validateError="errors[0]"
                                                 v-model="formData.classroom_id"
                                                 :state="errors[0] ? false : null">
                            </classroom-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <b-form-group :label="$t('allow_classroom_overlap')">
                        <b-form-checkbox v-model="formData.allow_classroom_overlap" :value="1">
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4" lg="6">
                    <b-form-group :label="$t('allow_instructor_overlap')">
                        <b-form-checkbox v-model="formData.allow_instructor_overlap" :value="1">
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="updateForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox"

// Services
import DailyCourseScheduleService from "@/services/DailyCourseScheduleService";

// Other
import { ValidationProvider, ValidationObserver } from "vee-validate"
import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";

export default {
    components: {
        ClassroomSelectbox,
        ProgramSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                status: "makeup",
                course_name: null,
                course_code: null,
                course_id: null,
                subject: null,
                instructor_id: null,
                subtitle: null,
                section: null,
                date: null,
                start_time: null,
                end_time: null,
                classroom_id: null,
                allow_classroom_overlap: null,
                allow_instructor_overlap: null,
            },
            coordinatorValue: {},
            formLoading: false,
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            DailyCourseScheduleService.get(id)
                .then(response => {
                    let data = response.data.data;
                    this.formData = {
                        course_name: data.course_name,
                        course_code: data.course_code,
                        course_id: data.course_id,
                        subject: data.subject,
                        instructor_id: data.instructor_id,
                        subtitle: data.subtitle,
                        section: data.section,
                        date: data.date,
                        start_time: data.start_time,
                        end_time: data.end_time,
                        classroom_id: data.classroom_id,
                        allow_classroom_overlap: data.allow_classroom_overlap,
                        allow_instructor_overlap: data.allow_instructor_overlap,
                        semester_id: data.semester_id,
                    }
                })
                .catch(e => {
                    this.showErrors(e)
                })
        },

        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.loading = true;
                let formData = {
                    ...this.formData,
                };

                return DailyCourseScheduleService.update(this.formId, formData)
                    .then((response) => {
                        this.$emit('createFormSuccess', true);
                        this.$toast.success(this.$t(response.data.message));
                    })
                    .catch((e) => {
                        this.showErrors(e);
                    }).finally(() => this.loading = false);
            }
        }
    }
}
</script>
